import { render, staticRenderFns } from "./EditProducts.vue?vue&type=template&id=283c8500&scoped=true&"
import script from "./EditProducts.vue?vue&type=script&lang=js&"
export * from "./EditProducts.vue?vue&type=script&lang=js&"
import style0 from "./EditProducts.vue?vue&type=style&index=0&id=283c8500&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283c8500",
  null
  
)

export default component.exports